import { useEffect } from 'react'

export const MOBILE_FOOTER_HEIGHT_CSS_VAR = '--mobile-footer-height'
const MOBILE_FOOTER_ELEMENT_ID = 'footer-mobile'

// Global CSS overrides (see Global.styles.ts) need to position mobile
// bottom-sheet modals right above the mobile footer navigation. That footer
// height comes from the design system and can change between versions, so
// instead of hardcoding a pixel value we measure the real rendered footer
// and expose it as a CSS variable that those overrides can consume.
export const useSyncMobileFooterHeightCssVar = () => {
  useEffect(() => {
    const footerElement = document.getElementById(MOBILE_FOOTER_ELEMENT_ID)

    if (!footerElement) return

    const measuredElement = footerElement.firstElementChild ?? footerElement

    const updateCssVar = () => {
      const { height } = measuredElement.getBoundingClientRect()

      if (height > 0) {
        document.documentElement.style.setProperty(
          MOBILE_FOOTER_HEIGHT_CSS_VAR,
          `${height}px`
        )
      }
    }

    updateCssVar()

    if (typeof ResizeObserver === 'undefined') return

    const resizeObserver = new ResizeObserver(updateCssVar)
    resizeObserver.observe(measuredElement)

    return () => resizeObserver.disconnect()
  }, [])
}
